import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";
import { Avatar, ErrorBox, Spinner } from "@/components/Bits";
import { useAdminGet } from "@/pages/admin/SuperAdmin";

function Reports({ onExpired }) {
  const { data, error, load } = useAdminGet("/superadmin/reports", onExpired);
  const resolve = async (path, action) => {
    try { await api.post(`/superadmin/reports/${path}`, { action }); toast.success(action === "remove" ? "Contenu retiré" : "Signalement classé"); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  if (error) return <ErrorBox message={error} />;
  if (!data) return <Spinner />;
  return (
    <section className="mpl-card space-y-3 p-4" data-testid="admin-reports">
      <h2 className="text-sm font-bold">Signalements</h2>
      {!data.comments.length && !data.avatars.length && <p className="text-xs text-slate-400">Aucun signalement en attente.</p>}
      {data.comments.map((c) => (
        <div key={c.id} className="flex flex-wrap items-center gap-2 text-xs" data-testid={`report-comment-${c.id}`}>
          <span className="flex-1 text-slate-300">« {c.body || "GIF"} » — {c.author} · {c.league} · {c.reports} signalement(s)</span>
          <button onClick={() => resolve(`comments/${c.id}`, "remove")} className="font-semibold text-red-300">Retirer</button>
          <button onClick={() => resolve(`comments/${c.id}`, "dismiss")} className="font-semibold text-slate-300">Classer</button>
        </div>
      ))}
      {data.avatars.map((a) => (
        <div key={a.id} className="flex flex-wrap items-center gap-2 text-xs" data-testid={`report-avatar-${a.user_id}`}>
          <Avatar user={a.member} size={32} /><span className="flex-1 text-slate-300">Photo de {a.member.display_name} {a.reason && `· « ${a.reason} »`}</span>
          <button onClick={() => resolve(`avatars/${a.user_id}`, "remove")} className="font-semibold text-red-300" data-testid={`report-avatar-remove-${a.user_id}`}>Retirer la photo</button>
          <button onClick={() => resolve(`avatars/${a.user_id}`, "dismiss")} className="font-semibold text-slate-300">Classer</button>
        </div>
      ))}
    </section>
  );
}

export default function Moderation({ onExpired }) {
  const [action, setAction] = useState("");
  const { data, error } = useAdminGet(`/superadmin/audit?action=${encodeURIComponent(action)}&limit=150`, onExpired);
  return (
    <div className="space-y-5">
      <Reports onExpired={onExpired} />
      <section className="mpl-card p-4" data-testid="admin-audit">
        <div className="mb-3 flex flex-wrap items-center justify-between gap-2"><h2 className="text-sm font-bold">Journal d'audit</h2>
          <select value={action} onChange={(e) => setAction(e.target.value)} className="mpl-input w-auto py-1 text-xs" data-testid="admin-audit-filter">
            <option value="">Toutes les actions</option><option value="superadmin.">Superadmin</option><option value="league.">Ligues</option><option value="role.">Rôles</option><option value="auth.">Connexion et mots de passe</option><option value="challenge.">Défis</option></select></div>
        {error && <ErrorBox message={error} />}
        {!data ? <Spinner /> : <ul className="max-h-[480px] space-y-1 overflow-y-auto text-xs">{data.map((e) => (
          <li key={e.id} className="flex flex-wrap gap-x-2 border-b border-white/[0.04] py-1.5 text-slate-300"><span className="font-mono-num text-slate-500">{fmtDateTime(e.created_at)}</span><b className="text-white">{e.action}</b><span>{e.actor}</span>
            {e.meta?.reason && <span className="text-slate-400">« {e.meta.reason} »</span>}</li>))}</ul>}
      </section>
    </div>
  );
}
